import React from 'react';
import { Radio } from 'antd';

const RadioComponent = ({ checked = false }) => {
    return <Radio checked={checked} />;
};

export default RadioComponent;
